import * as Api from './api';

export default { Api };
